<!-- abxDialogFocus (T-04, #816) moves focus to the FIRST focusable child on open.
     The first action below is the SAFE one ("Keep booking"), so the keyboard /
     screen-reader user lands on the non-destructive choice per DESIGN.md R-BTN-02. -->
<div abxDialogFocus>
  <h2 mat-dialog-title>{{ dialogEnum.CANCEL_DIALOG_HEADER }}</h2>
  <mat-dialog-content>
    <p>
      {{ dialogEnum.CANCEL_DIALOG_CONTENT_1 }}
      <br />
      {{ dialogEnum.CANCEL_DIALOG_CONTENT_2 }}
    </p>
    <!-- Cancel-policy note (#836): within/outside the cancellation window, derived
         client-side by the opener and passed via MAT_DIALOG_DATA. No dollar amount. -->
    <p class="cancel-policy" data-testid="cancel-policy">{{ policyMessage }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <!-- SAFE action first so it receives initial focus (R-BTN-02). -->
    <button mat-dialog-close class="btn">Keep booking</button>
    <button [mat-dialog-close]="true" class="btn btn-primary">Yes, Cancel</button>
  </mat-dialog-actions>
</div>
